import React from 'react';
import { css } from '@compiled/react';
import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';

import { Hero } from 'src/components/Hero';
import { ContentBlock } from 'src/pages/hubs/LearningPathPage/children/ContentBlock';
import { getImageAttrs } from 'src/utils/contentful';
import { LearningPathsHubLoaderProps } from 'src/pages/hubs/LearningPathPage/loader';

interface HubLayoutProps {
  hubData: LearningPathsHubLoaderProps['learningPathsHubData'];
}

export const HubLayout: React.FC<HubLayoutProps> = ({ hubData }) => (
  <main data-testid="learning-paths-hub" css={pageContainerStyles}>
    <Hero
      title={hubData.hero.titleExternal}
      subtitle={hubData.hero.subtitle}
      eyebrowText={hubData.hero.eyebrowText}
      showHeroDesktopImage={true}
    />

    <div data-testid="learning-paths-content-section" css={pageContentContainerStyles}>
      {!!hubData.linkedContentBlockCollection.items.length &&
        hubData.linkedContentBlockCollection.items.map((contentBlock) => (
          <ContentBlock
            key={contentBlock.sys.id}
            imageSrc={getImageAttrs(contentBlock.asset)?.src}
            title={contentBlock.titleExternal}
            subtitle={contentBlock.subtitle}
            associatedContent={contentBlock.associatedContentResourcesCollection.items}
          />
        ))}
    </div>
  </main>
);

const pageContainerStyles = css({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '136px',

  '@media (max-width: 1279px)': {
    marginTop: '0',
  },
});

const pageContentContainerStyles = css({
  width: '100%',
  height: '100%',
  maxWidth: '1022px',
  display: 'flex',
  padding: `0 ${token('space.300')}`,
  flexDirection: 'column',
  alignItems: 'flex-start',

  [media.below.xs]: {
    padding: `0 ${token('space.200')}`,
  },
});
